import Vue from 'vue'
import Router from 'vue-router'

import Main from '@/components/Main'

// 二级页面
import Secondary from '@/components/Secondary'
// 新闻列表
import New_list from '@/components/New_list'
// 新闻详细
import New_detail from '@/components/New_detail'
Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            redirect: '/index',
        },
        {
            path: '/index',
            name: 'index',
            component: Main
        },
        {
            path: '/secondary',
            redirect: '/new_list',
            name: 'secondary',
            component: Secondary,
            children: [
                {
                    path: '/new_list',
                    name: 'new_list',
                    component: New_list,
                },
                {
                    path: '/new_detail',
                    name: 'new_detail',
                    component: New_detail
                },
            ]
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js